import { showMockTelegramPopup } from '@focuslee/shared-mini-app';
import { emitEvent, mockTelegramEnv, PopupParams } from '@tma.js/sdk';
import { mockSafeAreaCssVars } from './helpers/telegram';

function shouldMockTelegramEnvFromUrl(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    const value = new URLSearchParams(window.location.search).get('mockTelegramEnv');
    return value === 'true';
}

// It is important, to mock the environment only for development purposes.
// When building the application the import.meta.env.DEV will value become
// `false` and the code inside will be tree-shaken (removed), so you will not
// see it in your final bundle.
if (process.env.REACT_APP_DEV === 'true') {
    await (async () => {
        // Only mock when explicitly requested via URL param in the browser.
        if (!shouldMockTelegramEnvFromUrl()) {
            return;
        }

        // In dev mode, always use REACT_APP_MOCK_INIT_DATA_RAW when not in Telegram
        // Skip retrieveLaunchParams() to avoid using cached/stored values
        const initDataRaw = process.env.REACT_APP_MOCK_INIT_DATA_RAW;
        const tgWebAppStartParam = new URLSearchParams(window.location.search).get('startapp') ?? undefined;
        if (!initDataRaw) console.warn('⚠️ REACT_APP_MOCK_INIT_DATA_RAW is not set. Please run: yarn scripts:mock-telegram');
        mockTelegramEnv({
            launchParams: {
                tgWebAppThemeParams: {
                    accent_text_color: '#6ab2f2',
                    bg_color: '#17212b',
                    button_color: '#5288c1',
                    button_text_color: '#ffffff',
                    destructive_text_color: '#ec3942',
                    header_bg_color: '#17212b',
                    hint_color: '#708499',
                    link_color: '#6ab3f3',
                    secondary_bg_color: '#232e3c',
                    section_bg_color: '#17212b',
                    section_header_text_color: '#6ab3f3',
                    subtitle_text_color: '#708499',
                    text_color: '#f5f5f5',
                },
                tgWebAppData: initDataRaw ?? '',
                tgWebAppStartParam,
                tgWebAppVersion: '8',
                tgWebAppPlatform: 'tdesktop',
            },
            // Telegram itself owns the invoice UI (native payment sheet); there's nothing for a
            // mocked web env to show. Auto-close it as "paid" so dev/e2e can exercise the mini-app
            // side of the payment flow without a real Telegram client or real money.
            onEvent(event, next) {
                if (event.name === 'web_app_open_popup') {
                    showMockTelegramPopup(event.params as PopupParams);
                    return;
                }
                if (event.name === 'web_app_open_invoice') {
                    const { slug } = event.params as { slug: string };
                    setTimeout(() => emitEvent('invoice_closed', { slug, status: 'paid' }), 0);
                    return;
                }
                next();
            },
        });

        if (typeof window !== 'undefined') {
            (window as any).__TELEGRAM_MOCKED__ = true;

            mockSafeAreaCssVars();
        }

        console.warn(
            '⚠️ As long as the current environment was not considered as the Telegram-based one, it was mocked. Take a note, that you should not do it in production and current behavior is only specific to the development process. Environment mocking is also applied only in development mode. So, after building the application, you will not see this behavior and related warning, leading to crashing the application outside Telegram.',
        );
    })();
}
